import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d042433"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden sm:block text-xs relative z-[60]" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text pr-8" }, "篩選", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "dropdown-content shadow-md rounded-sm"
}
const _hoisted_5 = { class: "px-[20px] w-[400px]" }
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = { class: "flex basis-full items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-medium text-sm mb-1" }, " 風格設計 ", -1))
const _hoisted_9 = { class: "g-collapse" }
const _hoisted_10 = { class: "flex gap-3 w-full text-right justify-end" }
const _hoisted_11 = { class: "sm:hidden text-xs relative z-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text pr-8" }, "篩選", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "g-mobile-filter-mask"
}
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = { class: "flex justify-end h-[50px] pr-[20px] pt-[18px]" }
const _hoisted_17 = { class: "h-[100vh]" }
const _hoisted_18 = { class: "flex flex-col px-[20px] h-[80%] overflow-y-auto" }
const _hoisted_19 = { class: "mb-8" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color font-medium text-sm mb-1" }, " 風格設計 ", -1))
const _hoisted_22 = { class: "g-collapse" }
const _hoisted_23 = { class: "flex gap-3 w-full justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_TransitionPlusButton = _resolveComponent("TransitionPlusButton")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_clickOutSide = _resolveDirective("clickOutSide")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "dropdown-title cursor-pointer",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args)))
      }, _hoisted_3),
      (_ctx.showContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "body", {}, () => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_Spacer),
                    _createVNode(_component_TransitionPlusButton, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show1 = !_ctx.show1)),
                      actived: !_ctx.show1
                    }, null, 8, ["actived"])
                  ]),
                  _createVNode(_component_Collapse, null, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_CheckBoxGroup, {
                          modelValue: _ctx.selectThemeListRef,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectThemeListRef) = $event)),
                          class: "text-sm"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyThemeList, (theme) => {
                              return (_openBlock(), _createBlock(_component_CheckBox, {
                                key: theme.CmdyThemeId,
                                text: theme.Name,
                                value: theme.CmdyThemeId
                              }, null, 8, ["text", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 512), [
                        [_vShow, _ctx.show1]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Btn, {
                    class: "text-sm",
                    type: "text",
                    text: '重置',
                    height: '50px',
                    width: '70px',
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cleanSelectTheme()))
                  }),
                  _createVNode(_component_Btn, {
                    class: "text-sm",
                    text: '完成',
                    height: '50px',
                    width: '70px',
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {
                  _ctx.$emit('getCmdyClassList');
                  _ctx.openFilter();
                })
                  })
                ])
              ])
            ], true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        class: "dropdown-title cursor-pointer",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args)))
      }, _hoisted_13),
      (_ctx.showContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["g-mobile-filter text-gary-text-color", [{ 'show-filter': _ctx.showContent }]])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Icon, {
                    iconName: "close",
                    width: '16px',
                    onClick: _ctx.openFilter
                  }, null, 8, ["onClick"])
                ]),
                _renderSlot(_ctx.$slots, "body", {}, () => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_Spacer),
                          _createVNode(_component_TransitionPlusButton, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.show1 = !_ctx.show1)),
                            actived: !_ctx.show1
                          }, null, 8, ["actived"])
                        ]),
                        _createVNode(_component_Collapse, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_CheckBoxGroup, {
                                modelValue: _ctx.selectThemeListRef,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectThemeListRef) = $event)),
                                class: "text-sm"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyThemeList, (theme) => {
                                    return (_openBlock(), _createBlock(_component_CheckBox, {
                                      key: theme.CmdyThemeId,
                                      text: theme.Name,
                                      value: theme.CmdyThemeId
                                    }, null, 8, ["text", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ], 512), [
                              [_vShow, _ctx.show1]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Btn, {
                        class: "text-sm",
                        type: "text",
                        text: '重置',
                        height: '36px',
                        width: '80px',
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cleanSelectTheme()))
                      }),
                      _createVNode(_component_Btn, {
                        class: "text-sm",
                        text: '完成',
                        height: '36px',
                        width: '80px',
                        onClick: _cache[9] || (_cache[9] = ($event: any) => {
                      _ctx.$emit('getCmdyClassList');
                      _ctx.openFilter();
                    })
                      })
                    ])
                  ])
                ], true)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_clickOutSide, _ctx.closeFilter]
  ])
}